






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ChartsViewModel, ChartsService } from '../../api/charts';
import ChartsList from './List.vue';
import ChartsEdit from './Edit.vue';
@Component({
  components: {
    ChartsList,
    ChartsEdit,
  },
})
export default class ChartsIndex extends Vue {
  private service: ChartsService = new ChartsService();
  private condition: ChartsViewModel = this.service.NewModel;
  private showEdit: boolean = false;
  private totalCount: number = 0;

  private list_OnLoaded(count: any) {
    console.log(count);
    this.totalCount = count;
  }
  private btnSearch_OnClick() {
    (this.$refs.chartsList as any).Search(this.condition, 1);
  }
}
